let subscribers={};function subscribe(eventName,callback){return subscribers[eventName]===void 0&&(subscribers[eventName]=[]),subscribers[eventName]=[...subscribers[eventName],callback],function(){subscribers[eventName]=subscribers[eventName].filter(cb=>cb!==callback)}}function publish(eventName,data){if(subscribers[eventName]){const promises=subscribers[eventName].map(callback=>callback(data));return Promise.all(promises)}else return Promise.resolve()}
//# sourceMappingURL=/cdn/shop/t/30/assets/pubsub.js.map?v=25310214064522200911791229140

/* Fallback goi y san pham site-wide (06/10) — xoa de go */
(function(){function boot(){document.querySelectorAll("product-recommendations").forEach(function(el){if(el.childElementCount>0||el.__knDone)return;el.__knDone=1;var u=el.dataset.url+"&product_id="+el.dataset.productId+"&section_id="+el.dataset.sectionId;fetch(u).then(function(r){return r.text()}).then(function(t){var d=document.createElement("div");d.innerHTML=t;var s=d.querySelector("product-recommendations");if(s&&s.innerHTML.trim().length&&el.childElementCount===0){el.innerHTML=s.innerHTML;}}).catch(function(){});});}if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",boot);}else{boot();}setTimeout(boot,1500);})();

/* BLACK FRIDAY BANNER goc trai (07/10/2026) — xoa tu dong nay toi het file de go */
(function(){
  if(window.__knBF)return;window.__knBF=1;
  function boot(){
    if(document.getElementById("kn-bf")||!document.body)return;
    var css=''
      +'#kn-bf{position:fixed;right:0;bottom:calc(16px + env(safe-area-inset-bottom,0px));z-index:9400;font-family:var(--kn-font,system-ui,-apple-system,sans-serif)}'
      +'#kn-bf.kn-bf--lift{bottom:calc(100px + env(safe-area-inset-bottom,0px))}'
      +'.kn-bf-tab{display:flex;flex-direction:column;align-items:center;gap:5px;background:#0c0d12;color:#fff;border:1px solid #33343f;border-right:0;border-radius:9px 0 0 9px;padding:8px 4px 10px;font:800 9px/1 inherit;letter-spacing:.7px;cursor:pointer;box-shadow:-3px 0 12px rgba(0,0,0,.3);animation:knbf-pulse 2.6s ease-in-out infinite}'
      +'.kn-bf-tab:hover{border-color:#ffb53d}'
      +'.kn-bf-vtxt{writing-mode:vertical-rl;text-orientation:mixed;white-space:nowrap}'
      +'.kn-bf-tab b{color:#ffb53d;font-weight:800}'
      +'.kn-bf-tab svg{width:11px;height:11px;flex:none}'
      +'@keyframes knbf-pulse{0%,100%{box-shadow:-3px 0 12px rgba(0,0,0,.3)}50%{box-shadow:-3px 0 14px rgba(255,181,61,.5)}}'
      +'@media (prefers-reduced-motion:reduce){.kn-bf-tab{animation:none}}'
      +'.kn-bf-panel{position:absolute;right:calc(100% + 10px);bottom:0;width:min(300px,calc(100vw - 72px));background:#0c0d12;color:#fff;border:1px solid #33343f;border-radius:16px;padding:18px 18px 16px;box-shadow:0 14px 44px rgba(0,0,0,.5);transform-origin:right bottom}'
      +'#kn-bf.kn-bf--open .kn-bf-panel{animation:knbf-out .22s ease}'
      +'@keyframes knbf-out{from{opacity:0;transform:translateX(8px) scale(.94)}to{opacity:1;transform:none}}'
      +'.kn-bf-x{position:absolute;top:8px;right:10px;background:none;border:0;color:#9b9daa;font-size:22px;line-height:1;cursor:pointer;padding:4px}'
      +'.kn-bf-x:hover{color:#fff}'
      +'.kn-bf-kick{margin:0;font-size:11px;font-weight:800;letter-spacing:2.5px;color:#ffb53d}'
      +'.kn-bf-big{margin:6px 0 10px;font-size:24px;line-height:1.15;font-weight:800;letter-spacing:-.3px}'
      +'.kn-bf-txt{margin:0 0 10px;font-size:13px;line-height:1.55;color:#c7c9d4}'
      +'.kn-bf-cta{display:block;text-align:center;background:#ffb53d;color:#14151b;border-radius:10px;padding:12px 14px;font-weight:800;font-size:13px;letter-spacing:.6px;text-decoration:none;margin-top:12px}'
      +'.kn-bf-cta:hover{filter:brightness(1.06)}';
    var st=document.createElement("style");st.textContent=css;document.head.appendChild(st);
    var w=document.createElement("div");w.id="kn-bf";
    w.innerHTML=''
      +'<button type="button" class="kn-bf-tab" aria-expanded="false" aria-controls="kn-bf-panel">'
      +'<svg viewBox="0 0 24 24" fill="none" stroke="#ffb53d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12v10H4V12"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>'
      +'<span class="kn-bf-vtxt">BLACK <b>FRIDAY</b></span>'
      +'</button>'
      +'<div class="kn-bf-panel" id="kn-bf-panel" role="dialog" aria-label="Black Friday sale" hidden>'
      +'<button type="button" class="kn-bf-x" aria-label="Close">&times;</button>'
      +'<p class="kn-bf-kick">BLACK FRIDAY</p>'
      +'<p class="kn-bf-big">25&ndash;50% OFF<br>storewide</p>'
      +'<p class="kn-bf-txt">Every product in the store is marked down 25&ndash;50% for Black Friday. The discount is already in the price you see &mdash; no code needed.</p>'
      +'<p class="kn-bf-txt">Multi-buy bundles save an extra 10&ndash;20% automatically at checkout.</p>'
      +'<a class="kn-bf-cta" href="/collections/all">SHOP THE SALE</a>'
      +'</div>';
    document.body.appendChild(w);
    if(document.querySelector(".kp-sticky"))w.classList.add("kn-bf--lift");
    var tab=w.querySelector(".kn-bf-tab"),panel=w.querySelector(".kn-bf-panel");
    function open(){panel.hidden=false;w.classList.add("kn-bf--open");tab.setAttribute("aria-expanded","true");}
    function close(){panel.hidden=true;w.classList.remove("kn-bf--open");tab.setAttribute("aria-expanded","false");}
    tab.addEventListener("click",function(){panel.hidden?open():close();});
    w.querySelector(".kn-bf-x").addEventListener("click",close);
    document.addEventListener("click",function(e){if(!w.contains(e.target))close();});
    document.addEventListener("keydown",function(e){if(e.key==="Escape")close();});
  }
  if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",boot);}else{boot();}
})();


/* === TIM KIEM TOAN STORE (08/10/2026) — xoa tu dong nay toi het file de go ===
   O #kn-q von chi loc 48 the cua trang hien tai. Khoi nay goi them
   /search/suggest.json cua Shopify (quet TOAN BO san pham: ten dai SEO, mo ta,
   tag) va ve dropdown ket qua duoi o tim kiem. Enter = sang trang /search day du. */
(function(){
  var q = document.getElementById('kn-q');
  if (!q) return;

  var wrap = q.parentElement || q;
  if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';

  var css = ''
    + '.kn-sg{position:absolute;top:calc(100% + 6px);right:0;width:min(420px,92vw);background:#fff;border:1px solid #dbe4f0;border-radius:14px;box-shadow:0 14px 40px rgba(16,42,84,.16);z-index:220;overflow:hidden}'
    + '.kn-sg[hidden]{display:none}'
    + '.kn-sg-h{padding:9px 14px;font-size:11px;font-weight:700;letter-spacing:.8px;text-transform:uppercase;color:#5b708c;background:#f4f7fb}'
    + '.kn-sg a.kn-sg-it{display:flex;gap:10px;align-items:center;padding:9px 12px;text-decoration:none;color:#14315c;border-top:1px solid #eef2f8}'
    + '.kn-sg a.kn-sg-it:hover{background:#f4f8ff}'
    + '.kn-sg-img{width:44px;height:44px;border-radius:8px;object-fit:cover;background:#f0f3f8;flex:none}'
    + '.kn-sg-t{font-size:13px;line-height:1.35;font-weight:600;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}'
    + '.kn-sg-p{margin-left:auto;font-size:13px;font-weight:700;white-space:nowrap}'
    + '.kn-sg-all{display:block;text-align:center;padding:10px;font-size:13px;font-weight:700;color:#1d4ed8;text-decoration:none;border-top:1px solid #eef2f8;background:#fafcff}'
    + '.kn-sg-none{padding:14px;font-size:13px;color:#5b708c}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var panel = document.createElement('div');
  panel.className = 'kn-sg'; panel.hidden = true;
  wrap.appendChild(panel);

  var seq = 0, tm;
  function esc(s){ var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function hide(){ panel.hidden = true; }

  function render(items, term){
    if (!items.length){
      panel.innerHTML = '<div class="kn-sg-h">Across the whole store</div><div class="kn-sg-none">No products found for "' + esc(term) + '".</div>';
      panel.hidden = false; return;
    }
    var h = '<div class="kn-sg-h">Across the whole store (' + items.length + ')</div>';
    items.forEach(function(p){
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      h += '<a class="kn-sg-it" href="' + p.url + '">'
        + (img ? '<img class="kn-sg-img" src="' + img + '&width=88" alt="" loading="lazy">' : '<span class="kn-sg-img"></span>')
        + '<span class="kn-sg-t">' + esc(p.title) + '</span>'
        + '<span class="kn-sg-p">$' + p.price + '</span></a>';
    });
    h += '<a class="kn-sg-all" href="/search?q=' + encodeURIComponent(term) + '&type=product">See all results &rarr;</a>';
    panel.innerHTML = h; panel.hidden = false;
  }

  function lookup(){
    var term = q.value.trim();
    if (term.length < 2){ hide(); return; }
    var my = ++seq;
    fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,body,tag')
      .then(function(r){ return r.json(); })
      .then(function(j){
        if (my !== seq) return;
        var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
        render(ps, term);
      })
      .catch(function(){});
  }

  q.addEventListener('input', function(){ clearTimeout(tm); tm = setTimeout(lookup, 320); });
  q.addEventListener('focus', function(){ if (q.value.trim().length >= 2) lookup(); });
  q.addEventListener('keydown', function(e){
    if (e.key === 'Enter'){ e.preventDefault(); var t = q.value.trim(); if (t) location.assign('/search?q=' + encodeURIComponent(t) + '&type=product'); }
    if (e.key === 'Escape') hide();
  });
  document.addEventListener('click', function(e){ if (!wrap.contains(e.target)) hide(); });
})();
